import WIDGETS from './widgets';

export default {
	name: 'surveys',
	spacing: 2,
	widgets: [{ content: WIDGETS.SURVEYS, breakpoints: { xs: 12 }, lazy_loading: 0 }],
};
